import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        document.querySelectorAll('.toc-table-list li a').forEach(link => {
            link.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href');

                // only handle hash links
                if (!targetId || !targetId.startsWith('#')) return;

                const target = document.querySelector(targetId);
                if (!target) return;

                e.preventDefault();

                const headerOffset = 92;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            });
        });

        // Only execute sticky header on pages that are NOT using page-drivealive.php template
    const isDriveAlivePage = document.body.classList.contains('page-template-page-drivealive');
    
    if (!isDriveAlivePage) {
        const stickyHeader = document.querySelector('.sticky-header');
        
        if (stickyHeader) {
            const stickyOffset = stickyHeader.offsetTop + 118;
            window.addEventListener('scroll', () => enableSticky(stickyHeader, stickyOffset));
        }

        function enableSticky(el, offset) {
            if (window.scrollY >= offset) {
                el.classList.add('sticky-enabled');
            } else {
                el.classList.remove('sticky-enabled');
            } 
        }
    }

    // Add scrolled class on homepage for header background effect
    const isHomePage = document.body.classList.contains('home');
    if (isHomePage) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 0) {
                document.body.classList.add('scrolled');
            } else {
                document.body.classList.remove('scrolled');
            }
        });
    }

        // Search button toggle
        const searchBtns = document.querySelectorAll('.btn-search');
        const searchWrap = document.querySelector('.search-form-wrap');
        const searchInput = searchWrap?.querySelector('input[type="text"]');

        if (searchBtns.length && searchWrap) {
            // Add close button dynamically
            if (!searchWrap.querySelector('.search-close')) {
                const closeBtn = document.createElement('button');
                closeBtn.className = 'search-close';
                closeBtn.setAttribute('aria-label', 'Close search');
                closeBtn.type = 'button';
                searchWrap.appendChild(closeBtn);
            }

            const closeBtn = searchWrap.querySelector('.search-close');

            // Open search
            const openSearch = () => {
                searchWrap.classList.add('is-open');
                searchBtns.forEach(btn => btn.classList.add('is-active'));
                // Focus input after transition
                setTimeout(() => {
                    if (searchInput) searchInput.focus();
                }, 350);
            };

            // Close search
            const closeSearch = () => {
                searchWrap.classList.remove('is-open');
                searchBtns.forEach(btn => btn.classList.remove('is-active'));
                if (searchInput) searchInput.blur();
            };

            // Toggle on button click
            searchBtns.forEach(btn => {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (searchWrap.classList.contains('is-open')) {
                        closeSearch();
                    } else {
                        openSearch();
                    }
                });
            });

            // Close button
            if (closeBtn) {
                closeBtn.addEventListener('click', closeSearch);
            }

            // Close on Escape key
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && searchWrap.classList.contains('is-open')) {
                    closeSearch();
                }
            });

            // Close when clicking outside
            document.addEventListener('click', function (e) {
                if (!e.target.closest('.btn-search') && !e.target.closest('.search-form-wrap')) {
                    closeSearch();
                }
            });

            if (searchInput) {
                searchInput.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter') {
                        const form = searchInput.closest('form');
                        if (form) {
                            const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
                            if (submitBtn) submitBtn.classList.add('submitting');
                        }
                    }
                });
            }
        }

    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    locationURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                    is_spanish,
                } = officeDetails.data;

                const directionLabel = is_spanish ? 'Direcciones' : 'Directions';
                const moreInfoLabel = is_spanish ? 'Más Info' : 'More Info';
                const phoneLabel = is_spanish ? 'Teléfono' : 'Phone';
                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<strong>${phoneLabel}: <a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">${phone}</a></strong>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   ${locationURL ? `<a href="${locationURL}" aria-label="More Info" class="btn btn-2">${moreInfoLabel}</a>` : ''}
                   <a href="${directionURL}" target="_blank" aria-label="${directionLabel}" class="btn btn-2">${directionLabel}</a>
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                if (officeHours) {
                officeHours.innerHTML = hoursOffice;
                }
            }
        }
    },
    

    /**
     * Open Image - Modal
     */
    openImageInNewWindow() {    
        const modals = document.querySelectorAll("[data-modal]");
        modals.forEach(function (trigger) {
          trigger.addEventListener("click", function (event) {
            event.preventDefault();
            const modal = document.getElementById(trigger.dataset.modal);
            modal.classList.add("open");
            const exits = modal.querySelectorAll(".modal-exit");
            exits.forEach(function (exit) {
              exit.addEventListener("click", function (event) {
                event.preventDefault();
                modal.classList.remove("open");
              });
            });
          });
        });
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButtons = document.querySelectorAll('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButtons.length > 0 && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks on ALL mobile buttons
                    mobileButtons.forEach((btn) => {
                        btn.addEventListener('click', () => drawer.open());
                    });

                    /**
                     * Close Button - attach to all close buttons
                     */
                    const closeButtons = document.querySelectorAll('.close__mobileMenu');
                    closeButtons.forEach((btn) => {
                        btn.addEventListener('click', () => drawer.close());
                    });

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;